import { type ItemDetails, LegacySegmentTypes } from '@1debit/analytics';
import { type AnchorHTMLAttributes, type CSSProperties, forwardRef } from 'react';

import { type AnalyticsId } from '../../client/AnalyticsProvider/AnalyticsProvider';
import { type AsChildProps, ClickableAnalyticsSlot } from '../../client/ClickableAnalyticsSlot';
import { Button, type ButtonWithIconProps } from '../Button/Button';

export type LinkElementProps = AnchorHTMLAttributes<HTMLAnchorElement>;

export type LinkDefaultProps = {
	analyticsId: AnalyticsId;
	style?: CSSProperties;
	className?: string;
	loading?: boolean;
	disabled?: boolean;
	itemDetails?: ItemDetails;
	itemValue?: string;
} & ButtonWithIconProps;

export type LinkProps = AsChildProps<LinkElementProps> & LinkDefaultProps;
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
	(
		{
			asChild,
			className,
			variant = 'link',
			size = 'standard',
			loading,
			disabled,
			analyticsId,
			iconProps,
			children,
			itemDetails,
			itemValue,
			...props
		},
		ref,
	) => {
		const isLink = variant === 'link' || variant === 'actionLink';
		return (
			<Button
				asChild
				className={className}
				loading={loading}
				disabled={disabled}
				analyticsId={null}
				{...(size === 'small' || isLink ? { size, variant } : { size, variant, iconProps })}>
				<ClickableAnalyticsSlot
					hidden={loading}
					asChild={asChild}
					ref={ref}
					{...props}
					analyticsId={analyticsId}
					trackElementType={LegacySegmentTypes.ElementType.ELEMENT_TYPE_LINK}
					itemDetails={itemDetails}
					itemValue={itemValue}
					defaultElement="a">
					{children}
				</ClickableAnalyticsSlot>
			</Button>
		);
	},
);
